import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useRights } from 'hooks';
import { AiService, AiTarget } from 'types';
import { RightSlug } from './ai-editor-button.types';
import { AiConstantsItem, SVG } from 'components';
import { Button, Hint } from 'components/ui';
import { AiEditor, AiPromo } from './components';
import { Icons } from 'assets';

type AnswerFormAiEditorProps<T extends AiService> = {
  mode: AiConstantsItem[];
  dialogTitle: string;
  entityType: AiTarget;
  rightSlug: RightSlug;
  apiService: T;
  text: string;
  disabled?: boolean;
  onApply: (result: string) => void;
};

export const AiEditorButton = observer(
  <T extends AiService>(props: AnswerFormAiEditorProps<T>) => {
    const {
      mode,
      dialogTitle,
      entityType,
      rightSlug,
      apiService,
      text,
      disabled,
      onApply,
    } = props;

    const aiRights = useRights(rightSlug);
    const [dialogOpen, setDialogOpen] = useState<
      'ai-editor' | 'ai-promo' | null
    >(null);

    const hintContent = disabled
      ? 'Текст слишком длинный, оставьте не более 4000 символов'
      : 'Улучшить текст с помощью ИИ';

    const handleSubmit = async (params: { text: string; style: string }) => {
      const response = await apiService.GenerateAiAnswer(params);

      return response.answer;
    };

    const handleAiOpen = () => {
      setDialogOpen(aiRights.update ? 'ai-editor' : 'ai-promo');
    };

    const handleCloseDialog = () => {
      setDialogOpen(null);
    };

    return (
      <>
        <Hint content={hintContent}>
          <Button
            leftIcon={<SVG src={Icons.AiGenerate} />}
            mode="additional"
            onClick={handleAiOpen}
            size={entityType === 'appeals' ? 'm' : 's'} // макеты пока не хотят приводить к общему виду
            style={{ cursor: 'pointer' }}
            disabled={disabled}
          >
            ИИ-редактор
          </Button>
        </Hint>

        <AiEditor
          open={dialogOpen === 'ai-editor'}
          onOpenChange={handleCloseDialog}
          originalText={text}
          modes={mode}
          onGenerate={handleSubmit}
          onApply={onApply}
          entityType={entityType}
        />

        <AiPromo
          dialogTitle={dialogTitle}
          open={dialogOpen === 'ai-promo'}
          onClose={handleCloseDialog}
          apiService={apiService}
        />
      </>
    );
  }
);
